// Objects comparing
/* eslint-disable dot-notation */
/* eslint-disable no-param-reassign */
Object.compare = (obj1, obj2) => {
  if (!obj1 || !obj2) {
    if (obj1 === obj2) {
      return true;
    }
    return false;
  }
  // Loop through properties in object 1
  const props1 = Object.getOwnPropertyNames(obj1);
  const props2 = Object.getOwnPropertyNames(obj2);
  if (props1.length !== props2.length) {
    // unequal number of props
    return false;
  }
  for (let i = 0; i < props1.length; i += 1) {
    const p = props1[i];
    // Check property exists on both objects
    if (Object.prototype.hasOwnProperty.call(obj1, p)
        !== Object.prototype.hasOwnProperty.call(obj2, p)) {
      // objects don't have same properties
      return false;
    }
    switch (typeof (obj1[p])) {
      // Deep compare objects
      case 'object':
        if (Array.isArray(obj1[p])) {
          if (obj1[p].length === 0 && obj2[p].length === 0) break;
          if (obj1[p].length !== obj2[p].length) {
            // unequal number of items in prop array
            return false;
          }
          let same = true;
          for (let j = 0; j < obj1[p].length; j += 1) {
            if (!Object.compare(obj1[p][j], obj2[p][j])) same = false;
          }
          if (!same) {
            // array items don't match
            return false;
          }
        } else {
          if (!Object.compare(obj1[p], obj2[p])) {
            // props don't match
            return false;
          }
          break;
        }
        break;
      // Compare values
      default:
        if (typeof obj1[p] === 'object') {
          if (!Object.compare(obj1[p], obj2[p])) {
            // items don't match
            return false;
          }
        } else if (obj1[p] !== obj2[p]) {
          // props don't match
          return false;
        }
    }
  }
  return true;
};

const checkForMatch = (item, cart) => {
  const item1 = JSON.parse(JSON.stringify(item));
  const itemFromCart = cart.find(itemCart => item1.catalogItemId === itemCart.catalogItemId);
  if (!itemFromCart) return null;
  const elementPos = cart.map(x => x.catalogItemId).indexOf(item1.catalogItemId);
  const matchName = JSON.stringify(item1.name) === JSON.stringify(itemFromCart.name);
  const matchStyle =
    JSON.stringify(item1.selectedStyle) === JSON.stringify(itemFromCart.selectedStyle);
  const matchSize =
    JSON.stringify(item1.selectedSize) === JSON.stringify(itemFromCart.selectedSize);
  const matchVariants =
    JSON.stringify(item1.selectedVariants) === JSON.stringify(itemFromCart.selectedVariants);
  const matchOptions =
    JSON.stringify(item1.selectedOptions) === JSON.stringify(itemFromCart.selectedOptions);

  if (matchName
  && matchStyle
  && matchSize
  && matchVariants
  && matchOptions) return elementPos;
  return null;
};


const storeState = {
  cart: [],
  orderType: '',
  voucher: '',
  comment: '',
  postalCode: {},
  addresses: [],
  addressesAT: [],
  addressesSet: false,
  contact: null,
  selectedAddress: null,
  modal: false,
  userData: undefined,
  intercomUser: undefined,
  intercomVisible: false,
  isFetchingUser: false,
};

const mutations = {
  pushCart(state, cart) {
    state.cart.push(cart);
  },
  setCart(state, cart) {
    state.cart = cart.map((current) => {
      const item = current;
      item.selected = false;
      return item;
    });
  },
  setUserData(state, data) {
    state.userData = data;
  },
  setIntercomUser(state, data) {
    state.intercomUser = data;
  },
  setIntercomVisible(state, data) {
    state.intercomVisible = data;
  },
  setIsFetchingUser(state, data) {
    state.isFetchingUser = data;
  },
  setComment(state, comment) {
    state.comment = comment;
  },
  setType(state, type) {
    state.orderType = type;
  },
  setVoucher(state, voucher) {
    state.orderVoucher = voucher;
  },
  setModal(state, type) {
    state.modal = type;
  },
  setAddresses(state, addresses) {
    state.addresses = addresses;
    state.addressesSet = true;
  },
  setAddressesAT(state, addresses) {
    state.addressesAT = addresses;
  },
  setContact(state, contact) {
    state.contact = contact;
  },
  chooseAddress(state, index) {
    state.selectedAddress = index;
  },
  removeAddress(state) {
    state.selectedAddress = null;
  },
  editCartItem(state, data) {
    state.cart[data.index] = data;
  },
  editCartItemQuantity(state, data) {
    let current = state.cart[data.index].quantity;
    if (data.action === 'dec' && current === 1) {
      state.cart.splice(data.index, 1);
      return;
    }
    current = data.action === 'dec' ? current - 1 : current + 1;
    state.cart[data.index].quantity = current;
  },
  addCartItem(state, data) {
    const matched = checkForMatch(data, state.cart);
    if (matched === null) {
      data.selected = false;
      state.cart.push(data);
    } else {
      state.cart[matched].quantity += data.quantity;
    }
  },
  selectItem(state, index) {
    state.cart = state.cart.map((current, i) => {
      const item = current;
      item.selected = i === index && !item.selected;
      return item;
    });
  },
  clearCart(state) {
    state.cart = [];
    state.comment = '';
    state.postalCode = {};
  },
  addPostal(state, data) {
    state.postalCode = data;
  },
  clearPostal(state) {
    state.postalCode = {};
  },
};

const getters = {
  cart() {
    return storeState.cart;
  },
  modal() {
    return storeState.modal;
  },
  userData() {
    return storeState.userData;
  },
  intercomUser() {
    return storeState.intercomUser;
  },
  intercomVisible() {
    return storeState.intercomVisible;
  },
  isFetchingUser() {
    return storeState.isFetchingUser;
  },
  addresses() {
    return storeState.addresses;
  },
  addressesAT() {
    return storeState.addressesAT;
  },
  addressesSet() {
    return storeState.addressesSet;
  },
  contact() {
    return storeState.contact;
  },
  selectedAddress() {
    return storeState.selectedAddress;
  },
  orderType() {
    return storeState.orderType;
  },
  postalCode() {
    return storeState.postalCode;
  },
  comment() {
    return storeState.comment;
  },
  orderInfo() {
    return {
      items: storeState.cart,
      orderType: storeState.orderType,
      comment: storeState.comment,
      voucher: storeState.voucher,
    };
  },
};

const actions = {
  setCart({ commit }, cart) {
    commit('setCart', cart);
  },
  setUserData({ commit }, data) {
    commit('setUserData', data);
  },
  setIntercomUser({ commit }, data) {
    commit('setIntercomUser', data);
  },
  setIntercomVisible({ commit }, data) {
    commit('setIntercomVisible', data);
  },
  setIsFetchingUser({ commit }, data) {
    commit('setIsFetchingUser', data);
  },
  selectItem({ commit }, index) {
    commit('selectItem', index);
  },
  setType({ commit }, type) {
    commit('setType', type);
  },
  setVoucher({ commit }, voucher) {
    commit('setVoucher', voucher);
  },
  setModal({ commit }, type) {
    commit('setModal', type);
  },
  setAddresses({ commit }, addresses) {
    commit('setAddresses', addresses);
  },
  setAddressesAT({ commit }, addresses) {
    commit('setAddressesAT', addresses);
  },
  setContact({ commit }, contact) {
    commit('setContact', contact);
  },
  chooseAddress({ commit }, index) {
    commit('chooseAddress', index);
  },
  removeAddress({ commit }) {
    commit('removeAddress');
  },
  setComment({ commit }, comment) {
    commit('setComment', comment);
  },
  pushCart({ commit }, cart) {
    commit('pushcart', cart);
  },
  editCartItem({ commit }, data) {
    commit('editCartItem', data);
  },
  addCartItem({ commit }, data) {
    commit('addCartItem', data);
  },
  clearCart({ commit }) {
    commit('clearCart');
  },
  editCartItemQuantity({ commit }, data) {
    commit('editCartItemQuantity', data);
  },
  addPostal({ commit }, data) {
    commit('addPostal', data);
  },
  clearPostal({ commit }) {
    commit('clearPostal');
  },
};

export default {
  state: storeState,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/cart.js